var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarTime = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 2a.5.5 0 0 1 .492.41L21 2.5V10a.5.5 0 0 1-.992.09L20 10l-.001-7.001L16.5 3a.5.5 0 0 1-.492-.41L16 2.5a.5.5 0 0 1 .41-.492L16.5 2h4ZM4.5 2a.5.5 0 0 1 .09.992L4.5 3 .999 2.999v15L9.5 18a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L9.5 19h-9a.5.5 0 0 1-.492-.41L0 18.5v-16a.5.5 0 0 1 .41-.492L.5 2h4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0h-3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm-.501.999v3h-2v-3h2ZM16.5 0h-3a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5Zm-.501.999v3h-2v-3h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2a.5.5 0 0 1 .09.992L13.5 3h-6a.5.5 0 0 1-.09-.992L7.5 2h6ZM20.5 7a.5.5 0 0 1 .09.992L20.5 8H.5a.5.5 0 0 1-.09-.992L.5 7h20ZM17.5 11c-1.79 0-3.33.638-4.596 1.904C11.638 14.169 11 15.71 11 17.5c0 1.79.638 3.33 1.904 4.596C14.169 23.362 15.71 24 17.5 24c1.79 0 3.33-.638 4.596-1.904C23.362 20.831 24 19.29 24 17.5c0-1.79-.638-3.33-1.904-4.596C20.831 11.638 19.29 11 17.5 11Zm0 1c1.524 0 2.811.533 3.89 1.61C22.466 14.69 23 15.977 23 17.5s-.533 2.811-1.61 3.89C20.31 22.466 19.023 23 17.5 23s-2.811-.533-3.89-1.61C12.534 20.31 12 19.023 12 17.5s.533-2.811 1.61-3.89C14.69 12.534 15.977 12 17.5 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.5a.5.5 0 0 1 .492.41L18 15l-.001 2.999L20 18a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L20 19h-2.5a.5.5 0 0 1-.492-.41L17 18.5V15a.5.5 0 0 1 .5-.5Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarTime);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar-time.bbae9ad7fb4e1dd042deed072e722b8c.svg";